module.exports = __webpack_public_path__ + "img/powerGrid-icon_4.267e0d46.png";